import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import { db } from "../../firebase-config";
import { collection, getDocs, query} from "firebase/firestore"

const BlufftonCourses = () => {

  let courseArray;
  const [courseData, setCourseData] = useState([]);
  const getCourses = async () =>{
    Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vTDqbzyY1nMKj9o3SzGzt-8_1mgxPZbnaDYAmYgKyKVASj8GLnInxFUWDUn_3xENAIP9JrAurDUYKEV/pub?gid=0&single=true&output=csv", {
      download: true,
      header: true,
      complete: (results) => {
  
        setCourseData(results.data)
      },
    });
  }

  useEffect(() =>{
    getCourses();
    console.log("get courses ran")
  }, []);

  useEffect(() =>{
    console.log("course data updated")
    console.log(courseData)
  }, [courseData])


  return (
    <div class="marqueeDiv">
    {/* <marquee class="bannerMessage">{bannerData[0]?.message}</marquee> */}
    <div class="mainContent">
      <h1>2025 Courses</h1>
      <h4>Courses are displayed in alphabetical order.<br></br>
        Goal is to play at least 55 different courses during the 2025 season.   <br></br>
      </h4>
        <table class="coursesTable">
          <thead>
            <tr>
              <th>Number</th>
              <th>Course Name</th>
              <th>City</th>
              <th>Region</th>
              <th>Digital Golf Pass Offer?</th>
              <th>Date</th>
              <th>Times Played</th>
            </tr>
          </thead>
          <tbody>
            {courseData.map(event =>{
              return (
                <tr key={event.number}>
                  <td class="numberData">{event.number}</td>
                  <td>{event.course}</td>
                  <td>{event.city}</td>
                  <td>{event.region}</td>
                  <td>{event.pass}</td>
                  <td>{event.date}</td>
                  <td class="numberData">{event.timesPlayed}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
    </div>
    </div>
  );
};

export default BlufftonCourses;